import { handleActions, combineActions } from 'redux-actions';
import update from 'react/lib/update';

import transcodingStatuses from 'shared/constants/transcoding-statuses';

import { NAMES as SERVER_VIDEOS_LIST } from 'dashboard/redux/server/actions/videos/list';
import { NAMES as SERVER_CHANNEL_VIDEOS_ADD } from 'dashboard/redux/server/actions/channel/videos/add';
import { NAMES as SERVER_CHANNEL_VIDEOS_REMOVE } from 'dashboard/redux/server/actions/channel/videos/remove';
import { NAMES as SERVER_CHANNEL_VIDEO_UPDATE } from 'dashboard/redux/server/actions/channel/video/update';
import { NAMES as SERVER_VIDEO_UPLOAD } from 'dashboard/redux/server/actions/video/upload';
import { NAMES as SERVER_VIDEO_UPDATE } from 'dashboard/redux/server/actions/video/update';
import { NAMES as SERVER_VIDEOS_UPDATE } from 'dashboard/redux/server/actions/videos/update';
import { NAMES as SERVER_VIDEOS_CREATE } from 'dashboard/redux/server/actions/videos/create';
import { NAMES as SERVER_VIDEO_GET } from 'dashboard/redux/server/actions/video/get';
import { NAMES as SERVER_CHANNEL_VIDEOS_LIST } from 'shared/redux/server/actions/channel/videos/list';
import { NAMES as SERVER_CHANNEL_REMOVE } from 'dashboard/redux/server/actions/channel/remove';
import { NAMES as CLIENT_TRANSCODING_UPDATE } from 'dashboard/redux/client/actions/transcoding/update';
import { NAMES as CLIENT_VIDEO_UPDATE } from 'shared/redux/client/actions/video/update';
import { NAMES as SERVER_VIDEO_REUPLOAD } from 'dashboard/redux/server/actions/video/reupload';


const MUTUAL_VIDEO_PROPS = [
  'on',
  'off',
  'coverUrl',
  'durationSec',
  'durationStr',
  'mediaFileName',
  'mediaInfo',
  'mediaType',
  'transcodingStatus',
  'uploadingStatus',
  'error',
];

const UPDATE_ACTIONS = [
  SERVER_VIDEO_UPLOAD.PROGRESS,
  SERVER_VIDEO_UPLOAD.FAIL,
  SERVER_VIDEOS_CREATE.SUCCESS,
  SERVER_VIDEO_UPDATE.START,
  CLIENT_VIDEO_UPDATE.SUCCESS,
  SERVER_VIDEO_UPDATE.SUCCESS,
  SERVER_VIDEOS_UPDATE.SUCCESS,
  SERVER_CHANNEL_VIDEO_UPDATE.SUCCESS,
  SERVER_VIDEO_REUPLOAD.START,
  SERVER_VIDEO_REUPLOAD.PROGRESS,
  SERVER_VIDEO_REUPLOAD.SUCCESS,
  SERVER_VIDEO_REUPLOAD.FAIL,
];

const ADD_ACTIONS = [
  SERVER_VIDEOS_LIST.SUCCESS,
  SERVER_VIDEO_UPLOAD.START,
  SERVER_VIDEO_UPLOAD.ITEM_CREATED,
  SERVER_CHANNEL_VIDEOS_LIST.SUCCESS,
  SERVER_CHANNEL_VIDEOS_ADD.SUCCESS,
  SERVER_VIDEO_GET.SUCCESS,
  SERVER_VIDEOS_CREATE.START,
  SERVER_VIDEOS_CREATE.ITEM_CREATED,
];

function addCrewCastKey(person) {
  return _.has(person, 'key') ? person : { ...person, key: _.uniqueId() };
}

function addPropsFromBaseItem(video, videos) {
  if (video.baseItemId && videos[video.baseItemId]) {
    _.assign(video, _.pick(videos[video.baseItemId], MUTUAL_VIDEO_PROPS));
  }
}

const getVideosFromResponse = payload => payload.response.data.entities.videos;

export default handleActions({
  [combineActions(...ADD_ACTIONS, ...UPDATE_ACTIONS)](state, { payload }) {
    const changedVideos = _.mapValues(getVideosFromResponse(payload), function (video, id) {
      if (_.isArray(video.crew)) {
        video.crew = _.map(video.crew, addCrewCastKey);
      }
      if (_.isArray(video.cast)) {
        video.cast = _.map(video.cast, addCrewCastKey);
      }

      // if channel video loaded - copy fields from base item
      addPropsFromBaseItem(video, state);

      return _.mergeWith({ ...state[id] }, video, function (a, b) {
        if (_.isArray(a) && _.isArray(b)) {
          return b;
        }
        if (b === transcodingStatuses.NONE) {
          return a || b;
        }
      });
    });

    return { ...state, ...changedVideos };
  },

  [SERVER_VIDEO_UPLOAD.SUCCESS]: (state, { payload }) => {
    // while uploading process I can edit my video item and the information from server can be outdated
    const clientProps = ['categories', 'description', 'customCoverUrl', 'tags', 'title'];

    const updateCommands = _.mapValues(getVideosFromResponse(payload), video => ({
      $merge: _.omit(video, clientProps),
    }));

    return update(state, updateCommands);
  },

  [SERVER_CHANNEL_VIDEOS_ADD.START]: (state, { payload }) => {
    const { id, videoIds } = payload.params;
    const updateCommands = {};

    _.forEach(videoIds, videoId => {
      updateCommands[videoId] = { usedInLists: { $push: [id] } };
    });

    return update(state, updateCommands);
  },

  [SERVER_CHANNEL_VIDEOS_REMOVE.START]: (state, { payload }) => {
    const { id, videoIds } = payload.params;
    const updateCommands = {};

    _.forEach(videoIds, videoId => {
      if (_.includes(state[videoId].usedInLists, id)) {
        updateCommands[videoId] = { usedInLists: { $apply: listsIds => _.without(listsIds, id) } };
      }
    });

    return update(state, updateCommands);
  },

  [SERVER_CHANNEL_REMOVE.SUCCESS]: (state, { payload }) => {
    const { id } = payload.params;
    const updateCommands = {};

    _.forEach(_.keys(state), videoId => {
      if (_.includes(state[videoId].usedInLists, id)) {
        updateCommands[videoId] = { usedInLists: { $apply: listsIds => _.without(listsIds, id) } };
      }
    });

    return update(state, updateCommands);
  },

  [CLIENT_TRANSCODING_UPDATE.SUCCESS]: (state, { payload }) => {
    const mediaFileName = payload.params.result;
    const videos = _.filter(state, { mediaFileName });
    const trailers = _.filter(state, { trailerFileName: mediaFileName });

    if (_.isEmpty(videos) && _.isEmpty(trailers)) {
      return state;
    }

    const { transcodingStatus } = payload.params.entities.videos[mediaFileName];
    const updateCommands = {};

    _.forEach(videos, video => {
      updateCommands[video.id] = {
        $merge: { transcodingStatus },
        mediaInfo: { $merge: { opStatus: transcodingStatus } },
      };
    });

    _.forEach(trailers, video => {
      updateCommands[video.id] = {
        $merge: { trailerTranscodingStatus: transcodingStatus },
        trailerInfo: { $merge: { opStatus: transcodingStatus } },
      };
    });

    return update(state, updateCommands);
  },
}, {});



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/entities/videos.js